const React = require('react');
const ExpandLessIcon = require('@material-ui/icons/ExpandLess').default;
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <div className="abs sr15 sb-60">
      <Ripple
        className={`layoutRow fhaC fvaC sq50 r ov bg dn1000
          o0 z-1 (z10|o50|o100:h!).show`
          + (props.show ? ' show' : '')}
        onClick={props.onClick}
      >
        <ExpandLessIcon
          className="sq40*2"
        />
      </Ripple>
    </div>
  );
};
